import { render } from "./FormItem.vue?vue&type=template&id=4298234b&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=4298234b&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4298234b"]])

export default __exports__